import { DocumentReference } from '@21st-night/utils';
import { DeckAnalyticsEvent } from '../../Analytics.types';

export function createAnalyticsEvent(
  deckRef: DocumentReference,
  data: DeckAnalyticsEvent,
): Promise<DocumentReference> {
  return deckRef.collection('analytics-events').add(data);
}
